import QuickAddButton from './QuickAddButton';

export default QuickAddButton;
